const RESTRICTED_PLAN_YEAR = '2025'
const CONNECT_PLAN_PREFIX = 'connect'
const FREE_PLAN_IDS = ['developer-free', 'q-internalfree']

/**
 * Determines whether a plan id represents an old (pre-2025) awork plan.
 * Mirrors the backend PlanClassifier so the frontend and backend agree on eligibility.
 * Works with subscription/pricing ids ('business-2023-1') and display ids ('business-2023').
 * @param {string | null | undefined} planId The plan id to classify.
 * @returns {boolean} True for old (pre-2025) plans; false for 2025, Connect, free, or missing ids.
 */
export function isOldPlan(planId: string | null | undefined): boolean {
  if (!planId || FREE_PLAN_IDS.includes(planId)) {
    return false
  }

  const normalized = planId.toLowerCase()
  const isRestricted = normalized.includes(RESTRICTED_PLAN_YEAR) || normalized.startsWith(CONNECT_PLAN_PREFIX)

  return !isRestricted
}
